export const userWelcomeTestId = 'ProfileMenu-user-welcome';
